var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fontIcon)?_c('v-icon',{attrs:{"color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))]):_c('inline-svg',{attrs:{"src":_vm.iconComponent}})
}
var staticRenderFns = []

export { render, staticRenderFns }